import { ref } from "vue";

/** Shared state: mobile drawer lives in Sidebar; trigger lives in PrivateHeader. */
const isMenuOpen = ref(false);

export function useMobileSidebarMenu() {
  function openMenu() {
    isMenuOpen.value = true;
  }

  function closeMenu() {
    isMenuOpen.value = false;
  }

  return {
    isMenuOpen,
    openMenu,
    closeMenu,
  };
}
